(function(){
    'use strict'

    angular
    .module('app.comprobantesPago')
    .controller('ComprobantesPago', ComprobantesPago);

    ComprobantesPago.$inject = ['$window', '$scope', '$animationsSrv', 'ComprobantesPagoService', 'logger', '$location', 'UserInfoService', 'TiposPlanillaService', 'CalendarizacionesService', 'PuestosService', 'DepartamentosService', 'apiSettings'];

    function ComprobantesPago($window, $scope, $animationsSrv, ComprobantesPagoService, logger, $location, UserInfoService, TiposPlanillaService, CalendarizacionesService, PuestosService, DepartamentosService, apiSettings) {
    
        $animationsSrv.scrollToTop();
        
        var vm = this;
        vm.tiposPlanilla = [];
        vm.planillas = [];
        vm.puestos = [];
        vm.departamentos = [];

        vm.details = [];
        vm.title = 'ComprobantesPago';

        vm.comprobantePago = {
            tipoPlanillaId: -1,
            calendarizacionId: -1,
            departamentoId: -1,
            puestoId: -1,
            nombre: '',
            identificacion: '',
            companiaId: UserInfoService.getCompaniaId()
        };

        vm.tipoPlanillaChange = function(tipoPlanillaId){
            if(tipoPlanillaId !== -1){
                $scope.comprobantePagoForm.tipoPlanillaId.$setValidity("different", true);
                vm.tipoPlanilla = vm.tiposPlanilla.find(function(tipo) {
                    return tipo.id == tipoPlanillaId;
                });
                getAllCalendarizaciones();          
            }
            else{
                if(tipoPlanillaId != null){
                    vm.planillas = [];
                    $scope.comprobantePagoForm.tipoPlanillaId.$setValidity("different", false);                    
                }
            }
        };

        vm.planillaChange = function(planillaId){
            if(planillaId !== -1){
                $scope.comprobantePagoForm.planillaId.$setValidity("different", true);
                vm.planilla = vm.planillas.find(function(p) {
                    return p.id == planillaId;
                });
            }
            else{
                if(planillaId != null){
                    $scope.comprobantePagoForm.planillaId.$setValidity("different", false);                    
                }
            }
        };


        getTiposPlanilla();
        getPuesto();
        getDepartamento();

        function getPuesto(){
            var promise = PuestosService.getAll()
            .then(function(puestos){
                vm.puestos = puestos;
            })
            .catch(function(error){
                $logger.error('Error al obtener los puestos.');
            }); 
            
            return promise;
        };

        function getDepartamento(){
            var promise = DepartamentosService.getAll(UserInfoService.getCompaniaId())
            .then(function(departamentos){
                vm.departamentos = departamentos;
            })
            .catch(function(error){
                $logger.error('Error al obtener los departamentos.');
            }); 
            
            return promise;
        };

        function getTiposPlanilla(){
            var promise = TiposPlanillaService.getAllForCalendarizacion(UserInfoService.getCompaniaId())
            .then(function(tiposPlanilla){
                tiposPlanilla.forEach(tipo => {
                    tipo.fechaInicio = moment(tipo.fechaInicio).toDate();
                    tipo.fechaFinal = moment(tipo.fechaFinal).toDate();
                });
                vm.tiposPlanilla = tiposPlanilla;
            })
            .catch(function(error){
                $logger.error('Error al obtener los tipos de planilla.');
            }); 
            
            return promise;
        };

        function getAllCalendarizaciones(){

            var promise = CalendarizacionesService.getAllCerradas(UserInfoService.getCompaniaId(), vm.tipoPlanilla.id);

            promise
            .then(function(calendarizaciones){
                calendarizaciones.forEach(calendarizacion => {
                    calendarizacion.fechaInicio = moment(calendarizacion.fechaInicio).toDate();
                    calendarizacion.fechaFinal = moment(calendarizacion.fechaFinal).toDate();
                });
                vm.planillas = calendarizaciones;
            })
            .catch(function(error){
                switch (error.status) {
                    case 401:
                        logger.error('La sessión ha terminado.');
                        break;
                
                    default:
                        logger.error('Error al obtener las Planillas.');
                        break;
                }
                
            });
        };

        function validateTipoPlanilla(){
            if(vm.comprobantePago.tipoPlanillaId == -1){
                $scope.comprobantePagoForm.tipoPlanillaId.$setValidity("different", false);
            }
            else{
                $scope.comprobantePagoForm.tipoPlanillaId.$setValidity("different", true);
            }
        };

        function validatePlanilla(){
            if(vm.comprobantePago.calendarizacionId == -1){
                $scope.comprobantePagoForm.planillaId.$setValidity("different", false);
            }
            else{
                $scope.comprobantePagoForm.planillaId.$setValidity("different", true);
            }
        };

        function doFormValidations(){
            validateTipoPlanilla();
            validatePlanilla();
        };

        vm.enviarComprobantes = function(){
            
            $scope.submitted = true;
            doFormValidations();

            if(!$scope.comprobantePagoForm.$valid){
                return;
            }

            var promise = ComprobantesPagoService.generarComprobantes(vm.comprobantePago);

            promise
            .then(function(comprobantesPago){
                vm.details = comprobantesPago.data;
                logger.success("Comprobantes de Pago generados!");
            })
            .catch(function(error){
                switch (error.status) {
                    case 401:
                        logger.error('La sessión ha terminado.');
                        break;
                
                    default:
                        logger.error('Error al generar los comprobantes.');
                        break;
                }
            });

        };

        vm.enviarComprobante = function(cp){
            
            var searchCriteria = {
                calendarizacionId: cp.calendarizacionId,
                departamentoId: -1,
                puestoId: -1,
                nombre: cp.empleadoNombre,
                identificacion: cp.numeroIdentificacion,
                companiaId: UserInfoService.getCompaniaId()
            };

            var promise = ComprobantesPagoService.generarComprobante(searchCriteria);

            promise
            .then(function(comprobantesPago){
                var item = comprobantesPago.data[0];
                vm.details.forEach(cp=>{
                    if(cp.numeroIdentificacion == item.numeroIdentificacion && cp.empleadoNombre == item.empleadoNombre){
                        cp.comprobantePago = item.comprobantePago;
                    }
                });
                logger.success("Comprobante de Pago generado!");
            })
            .catch(function(error){
                switch (error.status) {
                    case 401:
                        logger.error('La sessión ha terminado.');
                        break;
                
                    default:
                        logger.error('Error al generar los comprobantes.');
                        break;
                }
            });

        };

        vm.search = function() {

            $scope.submitted = true;
            doFormValidations();

            if(!$scope.comprobantePagoForm.$valid){
                return;
            }

            var promise = ComprobantesPagoService.getAll(vm.comprobantePago);

            promise
            .then(function(comprobantesPago){
                vm.details = comprobantesPago.data;
            })
            .catch(function(error){
                switch (error.status) {
                    case 401:
                        logger.error('La sessión ha terminado.');
                        break;
                
                    default:
                        logger.error('Error al obtener los datos.');
                        break;
                }
            });
        };
        
        vm.forTesting = function() {

            var promise = ComprobantesPagoService.generarComprobanteTest(vm.comprobantePago);

            promise
            .then(function(){
                logger.info('Comprobante Generado!');
            })
            .catch(function(error){
                switch (error.status) {
                    case 401:
                        logger.error('La sessión ha terminado.');
                        break;
                
                    default:
                        logger.error('Error al generar el comprobante.');
                        break;
                }
            });
        };

        vm.openComprobante = function(comprobante){
            var url = apiSettings.apiBaseUrl + '/' + comprobante.comprobantePago;
            $window.open(url, '_blank');
        };

        vm.openAllComprobante = function(){
            
            vm.details.forEach(cp => {
                var url = apiSettings.apiBaseUrl + '/' + cp.comprobantePago;
                window.open(url, cp.empleadoNombre);
            });
        };

        vm.generarTodos = function(){

            $scope.submitted = true;
            doFormValidations();

            if(!$scope.comprobantePagoForm.$valid){
                return;
            }
            
            var promise = ComprobantesPagoService.generarTodosEnUnPDF(vm.comprobantePago);

            promise
            .then(function(result){
                logger.info('PDF descargado!');
            })
            .catch(function(error){
                switch (error.status) {
                    case 401:
                        logger.error('La sessión ha terminado.');
                        break;
                
                    default:
                        logger.error('Error al generar el PDF.');
                        break;
                }
            });
        };

    }
})();